import request from '@/utils/request'

// 更新卡信息
export function updateSimCardsInfo(data) {
  return request({
    url: `/batch_operations/sim_cards/update_info`,
    method: 'post',
    data
  })
}

// 更新卡信息
export function updateCarrierSimCardsInfo(data) {
  return request({
    url: `/batch_operations/carrier_sim_cards/update_info`,
    method: 'post',
    data
  })
}

// 运营商卡号列表 删卡退库
export function deleteCarrierSimCardsToInventory(data) {
  return request({
    url: `/batch_operations/carrier_sim_cards/delete_to_inventory`,
    method: 'post',
    data
  })
}

// 供应商已划拨模组列表 删模组退库
export function deleteModulesToInventory(data) {
  return request({
    url: `/batch_operations/modules/delete_to_inventory`,
    method: 'post',
    data
  })
}

// 供应商已划拨 CPE 列表 删CPE退库
export function deleteCpesToInventory(data) {
  return request({
    url: `/batch_operations/cpes/delete_to_inventory`,
    method: 'post',
    data
  })
}

// 运营商卡号列表 强制断网
export function forceNetDownCarrierSimCards(data) {
  return request({
    url: `/batch_operations/carrier_sim_cards/force_net_down`,
    method: 'post',
    data
  })
}

// 运营商卡号列表 取消强制断网
export function cancelForceNetDownCarrierSimCards(data) {
  return request({
    url: `/batch_operations/carrier_sim_cards/cancel_force_net_down`,
    method: 'post',
    data
  })
}

// 融合卡绑定子卡
export function bindMixCarrierCard(data) {
  return request({
    url: `/batch_operations/carrier_sim_cards/bind_mix_carrier_card`,
    method: 'post',
    data
  })
}

// 客户卡号列表 强制断网
export function forceNetDownAgentSimCards(data) {
  return request({
    url: `/batch_operations/sim_cards/force_net_down`,
    method: 'post',
    data
  })
}

// 客户卡号列表 取消强制断网
export function cancelForceNetDownAgentSimCards(data) {
  return request({
    url: `/batch_operations/sim_cards/cancel_force_net_down`,
    method: 'post',
    data
  })
}

// 设置卡测试流量
export function setTestTrafficSimCards(data) {
  return request({
    url: `/batch_operations/sim_cards/set_test_traffic`,
    method: 'post',
    data
  })
}

// 延长沉默期（仅沉默期卡）
export function extendSilentPeriodSimCards(data) {
  return request({
    url: `/batch_operations/sim_cards/extend_silent_period`,
    method: 'post',
    data
  })
}

// 调整服务周期（仅可用卡）
export function adjustServicePeriodSimCards(data) {
  return request({
    url: `/batch_operations/sim_cards/adjust_service_period`,
    method: 'post',
    data
  })
}

// 自动续期
export function setAutoRenewSimCards(data) {
  return request({
    url: `/batch_operations/sim_cards/auto_renew`,
    method: 'post',
    data
  })
}

// 更新库存卡信息
export function updateSimCardInventoriesInfo(data) {
  return request({
    url: `/batch_operations/sim_card_inventories/update_info`,
    method: 'post',
    data
  })
}

// 库存卡批量操作选项数据
export function findInventoryBatchOperationOptions() {
  return [
    { label: '变更库房', value: 'change_warehouse' },
    { label: '变更运营商套餐', value: 'change_carrier_product' },
    { label: '融合卡绑定', value: 'bind_mix_carrier_card' },
    { label: '删除SIM卡', value: 'delete' },
    { label: '数据更新', value: 'update_info' }
  ]
}

// 客户卡号列表 退订套餐
export function unsubscribePackageAgentSimCards(data) {
  return request({
    url: `/batch_operations/sim_cards/unsubscribe_package`,
    method: 'post',
    data
  })
}

// 客户卡号列表 上报语音白名单
export function uploadWhiteListAgentSimCards(data) {
  return request({
    url: `/batch_operations/sim_cards/upload_white_list`,
    method: 'post',
    data
  })
}

// 客户卡号列表 验证变更运营商套餐卡号
export function validateChangeSimCardsCarrierProduct(data) {
  return request({
    url: `/batch_operations/sim_cards/change_carrier_product/validate`,
    method: 'post',
    timeout: 600 * 1000,
    data
  })
}

// 客户卡号列表 变更运营商套餐
export function changeSimCardsCarrierProduct(data) {
  return request({
    url: `/batch_operations/sim_cards/change_carrier_product`,
    method: 'post',
    data
  })
}

// 客户卡号列表 融合卡强制激活卡
export function servActiveAgentSimCards(data) {
  return request({
    url: `/batch_operations/sim_cards/serv_active`,
    method: 'post',
    data
  })
}

// 运营商批量操作选项数据
export function findCarrierBatchOperationOptions() {
  return [
    { label: '数据更新', value: 'update_info' },
    { label: '强制断网', value: 'force_net_down' },
    { label: '取消强制断网', value: 'cancel_force_net_down' },
    { label: '变更运营商套餐', value: 'change_carrier_product' },
    { label: '删卡退库', value: 'delete_to_inventory' }
  ]
}

// 客户卡批量操作选项数据
export function findSimCardBatchOperationOptions() {
  return request({
    url: `/batch_operations/sim_cards/options`,
    method: 'get'
  })
}

// 提请销卡
export function requestCancelCard(data) {
  return request({
    url: `/batch_operations/sim_cards/request_cancel_card`,
    method: 'post',
    data
  })
}

// 已销转待销
export function canceledToToBeCanceled(data) {
  return request({
    url: `/batch_operations/sim_cards/canceled_to_to_be_canceled`,
    method: 'post',
    data
  })
}

// 验证VPDN分组配置卡号
export function validateAllSimCardsUpdateVpdn(data) {
  return request({
    url: `/batch_operations/sim_cards/update_vpdn/validate`,
    method: 'post',
    timeout: 600 * 1000,
    data
  })
}

// VPDN分组配置卡号
export function allSimCardsUpdateVpdn(data) {
  return request({
    url: `/batch_operations/sim_cards/update_vpdn`,
    method: 'post',
    timeout: 600 * 1000,
    data
  })
}
// 销卡
export function cancelSimCard(data) {
  return request({
    url: `/batch_operations/sim_cards/cancel_card`,
    method: 'post',
    data
  })
}
